import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconHeadsetSharpLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 5.887A6.113 6.113 0 0 0 5.887 12v.778h3.556v7.336H3.887V12a8.113 8.113 0 0 1 16.227 0v8.114h-5.557v-7.336h3.557V12A6.113 6.113 0 0 0 12 5.887Zm6.114 8.892h-1.557v3.335h1.557v-3.336ZM5.887 16.445v-1.668h1.556v3.336H5.887v-1.668Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconHeadsetSharpLine);
export default Memo;
